import PropTypes from 'prop-types'
import { useEffect, useMemo, useState } from 'react'
import SweetAlert from 'react-bootstrap-sweetalert'
import { connect } from 'react-redux'
import { Input } from 'reactstrap'

const MfSweetAlert = props => {
  const [value, setValue] = useState('')

  const confirmBtnCssClass = useMemo(() => {
    if (!props.sweetAlert.confirmText) {
      return 'text-white'
    }
    return props.sweetAlert.confirmText.toLowerCase() !== value.toLowerCase() ? 'disabled' : 'text-white'
  }, [props.sweetAlert.confirmText, value])

  const customStyle = useMemo(
    () => (props.sweetAlert.width ? { width: props.sweetAlert.width, margin: '0 auto' } : undefined),
    [props.sweetAlert.width]
  )

  const confirmInputStyle = useMemo(() => {
    const base = { margin: '12px auto 0', width: '260px', maxWidth: '100%', display: 'block' }
    const widthOverride = props.sweetAlert.confirmInputWidth ? { width: props.sweetAlert.confirmInputWidth } : {}
    return { ...base, ...widthOverride, ...(props.sweetAlert.confirmInputStyle || {}) }
  }, [props.sweetAlert.confirmInputWidth, props.sweetAlert.confirmInputStyle])

  // Clear input whenever the alert visibility changes to avoid persisting typed text
  useEffect(() => {
    if (!props.sweetAlert.show) {
      setValue('')
    }
  }, [props.sweetAlert.show])

  return (
    <SweetAlert
      {...props.sweetAlert}
      confirmBtnCssClass={confirmBtnCssClass}
      style={customStyle}
      onConfirm={() => {
        if (props.sweetAlert.confirmInput) {
          setValue('')
          props.sweetAlert.onConfirm(value)
          return
        }
        props.sweetAlert.onConfirm()
      }}
    >
      {typeof props.sweetAlert.alertMessage === 'function'
        ? props.sweetAlert.alertMessage()
        : props.sweetAlert.alertMessage}
      {props.sweetAlert.confirmInput ? (
        <Input
          placeholder={props.sweetAlert.confirmInputPlaceholder}
          style={confirmInputStyle}
          value={value}
          onChange={e => setValue(e.target.value)}
        />
      ) : null}
    </SweetAlert>
  )
}

MfSweetAlert.propTypes = {
  sweetAlert: PropTypes.shape({
    alertMessage: PropTypes.oneOfType([PropTypes.string, PropTypes.func]).isRequired,
    width: PropTypes.string
  })
}

const mapStateToProps = state => {
  return {
    sweetAlert: state.sweet_alert || {}
  }
}

export default connect(mapStateToProps, {})(MfSweetAlert)
